export const initialState = {
    theme: { primary: 'yellow' },
    inspectionPlan: null,
    measurementFiles: []
};


export const reducer = (state, action) => {
    switch (action.type) {
        case 'changeTheme':
            return {
                ...state,
                theme: action.newTheme
            };
        case 'selectedIP':
            return {
                ...state,
                inspectionPlan: action.payload
            }
        case 'addFile':
            return{
                ...state,
                measurementFiles: [action.payload, ...state.measurementFiles]
            }
        case 'loadFilesArray':
            return{
                ...state,
                measurementFiles: action.payload
            }
        case 'loadSuppCapabilityArray':
                return{
                    ...state,
                    SupplierCapability: action.payload
                }
        default:
            return state;
    }
};
